'use client';

import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from '../store';
import { initializeAuth } from '../store/slices/authSlice';
import { ToastProvider } from '../components/ui/Toast';
import { usePersona } from '../shared/hooks/usePersona';
import { useCloudSync } from '../shared/hooks/useCloudSync';
import BottomTabBar from '../components/layout/BottomTabBar';

function AuthInitializer({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // 앱 로드 시 localStorage에서 인증 상태 복원
    store.dispatch(initializeAuth());
  }, []);

  return <>{children}</>;
}

/** Initializes cloud data sync after authentication */
function CloudSyncInitializer({ children }: { children: React.ReactNode }) {
  useCloudSync();
  return <>{children}</>;
}

/** Sets data-persona attribute on <html> and applies CSS custom properties */
function PersonaInitializer({ children }: { children: React.ReactNode }) {
  // Hook reads localStorage and applies data-persona + CSS vars to document
  usePersona();
  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <AuthInitializer>
        <CloudSyncInitializer>
        <PersonaInitializer>
          <ToastProvider>
            {children}
            <BottomTabBar />
          </ToastProvider>
        </PersonaInitializer>
        </CloudSyncInitializer>
      </AuthInitializer>
    </Provider>
  );
}